import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const detectInitialLanguage = () => {
  const browserLang = (navigator.languages && navigator.languages[0]) || navigator.language || "";
  const lang = String(browserLang).toLowerCase();
  if (lang.startsWith("zh")) return "ft";
  if (lang.startsWith("en")) return "en";
  return "en";
};

const state = {
  loginShow: false,
  preRegistrationShow: false,
  // 使用 loginInfo 持久化登录信息（含过期时间）
  loginInfo: JSON.parse(localStorage.getItem("loginInfo")) || {},
  preEmail: JSON.parse(localStorage.getItem("preEmail")) || {},
  content: {},
  language: detectInitialLanguage(),
  uniqueId: localStorage.getItem("uniqueId") || "",
  pkgId: 807497769,
  // 通过分享链接进入时的分享方唯一ID
  sharedUuid: "",
  // 通过分享链接携带的平台渠道
  sharedChannel: "",
  // 分享id
  shareRecordId: "",
};
const mutations = {
  toggleLoginPopup(state, show) {
    state.loginShow = show;
  },
  togglePreRegistrationPopup(state, show) {
    state.preRegistrationShow = show;
  },
  // 保存登录信息，持久化并带过期时间（3天）
  saveLoginInfo(state, loginData) {
    const data = {
      value: loginData, // 实际数据（服务端返回的 map）
      expires: Date.now() + 24 * 60 * 60 * 1000 * 3, // 过期时间（绝对时间戳）
    };
    localStorage.setItem("loginInfo", JSON.stringify(data));
    state.loginInfo = data;
  },
  // 安全更新持久化的登录字段（仅在已有且未过期时生效）
  updateLoginInfo(state, partial) {
    try {
      if (!state.loginInfo) return;
      const current = state.loginInfo;
      if (!current || !current.value || !current.expires) return;
      if (current.expires <= Date.now()) {
        // 已过期则不更新，保持未登录状态
        return;
      }
      const data = {
        value: { ...current.value, ...partial },
        expires: current.expires,
      };
      localStorage.setItem("loginInfo", JSON.stringify(data));
      state.loginInfo = data;
    } catch (e) {
      // 解析异常则忽略更新，避免错误状态
    }
  },
  setContent(state, payload) {
    const { key, data } = payload;
    state.content[key] = data;
  },
  setLanguage(state, type) {
    state.language = type;
  },
  setUniqueId(state, value) {
    state.uniqueId = value;
    localStorage.setItem("uniqueId", value);
  },
  setSharedUuid(state, value) {
    state.sharedUuid = value || "";
  },
  setSharedChannel(state, value) {
    state.sharedChannel = value || "";
  },
  setShareRecordId(state, value) {
    state.shareRecordId = value || "";
  },
  setPreEmail(state, value) {
    const expires = Date.now() + 3 * 24 * 60 * 60 * 1000;
    const data = { value, expires };
    localStorage.setItem("preEmail", JSON.stringify(data)); // 存储到 localStorage
    state.preEmail = data;
  },
};
const actions = {
  showLoginPopup({ commit }, show) {
    commit("toggleLoginPopup", show);
  },
  showPreRegistrationPopup({ commit }, show) {
    commit("togglePreRegistrationPopup", show);
  },
};
const getters = {
  isLoginPopupVisible(state) {
    return state.loginShow;
  },
  isPreRegistrationPopupVisible(state) {
    return state.preRegistrationShow;
  },
  // 解析并返回有效的登录信息对象，否则返回 null
  getLoginInfo(state) {
    if (!state.loginInfo) return null;
    try {
      const parsed = state.loginInfo;
      if (parsed && parsed.value && parsed.expires) {
        if (parsed.expires > Date.now()) {
          return parsed.value;
        } else {
          localStorage.removeItem("loginInfo");
          return null;
        }
      } else {
        localStorage.removeItem("loginInfo");
        return null;
      }
    } catch (e) {
      localStorage.removeItem("loginInfo");
      return null;
    }
  },
  // 兼容提供 email 获取
  getEmail(state, getters) {
    const info = getters.getLoginInfo;
    return info && info.email ? info.email : "";
  },
  getContent(state) {
    return state.content;
  },
  getLanguage(state) {
    return state.language;
  },
  getUniqueId(state) {
    return state.uniqueId;
  },
  getSharedUuid(state) {
    return state.sharedUuid;
  },
  getSharedChannel(state) {
    return state.sharedChannel;
  },
  getPkgId(state) {
    return state.pkgId;
  },
  // 是否已登录
  isLoggedIn(state, getters) {
    return !!getters.getLoginInfo;
  },
  getShareRecordId(state) {
    return state.shareRecordId;
  },
  getPreEmail(state) {
    const storedData = JSON.parse(localStorage.getItem("preEmail"));
    console.log("storedData", storedData);
    if (storedData && storedData.expires > Date.now()) {
      // 如果未过期，返回存储的值
      return storedData.value;
    } else {
      // 如果已过期，删除并返回空值
      localStorage.removeItem("preEmail");
      return "";
    }
  },
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
});



// WEBPACK FOOTER //
// ./src/store/index.js